import React, { useState, useEffect } from "react";
import { Form, FormGroup, Spinner, Button, ButtonGroup, Row, Col, Label, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { PersonType } from "../types";
import PhysicalPersonProfile from "../Forms/PhysicalPerson";
import JuridicalPersonProfile from "../Forms/JuridicalPerson";
import ModalError from "../../Modal/ModalError";
import { preCheckPersonForm } from "../../preCheckForms";
import { PersonMode, PersonQualification } from "../../../../utils/Helper";
import { SelectFormField, FormField } from "../../../../utils/FormFields";
import ModalConfirm from "../../Modal/ModalConfirm";
import PersonSubAsset from "../Forms/PersonSubAsset";

const PersonProfileTab = ({
  person,
  setPersonData,
  professions,
  activitySectors,
  publicPositions,
  personLinks,
  documentTypes,
  companyLinks,
  patrimonies,
  entityTypes,
  societyTypes,
  subAssetClasses,
  services,
  role,
  mode,
  onboarding,
  holder,
  isPerson,
  handleRedirectPerson,
  refresh,
  manual,
  needsExtraFields,
  viewDigitalRelatedFrom,
  userSession,
  newOnboardingVersion,
  currencies,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [checking, setChecking] = useState(false);
  const [changedPerson, setChangedPerson] = useState({});
  const [changedLegalAddress, setChangedLegalAddress] = useState({});
  const [checked, setChecked] = useState([]);
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });
  const [disabled, setDisabled] = useState(true);
  const [autosuggests, setAutosuggests] = useState({
    PersonFiscalResidenceCountry: "",
    PhysicalPersonCountryOfBirth: "",
    SpouseDocumentCountryOfIssue: "",
    LegalAddressCountry: "",
    PersonActivitySector: "",
    PersonSecondActivitySector: "",
    JuridicalPersonConstPlace: "",
  });
  const [errors, setErrors] = useState({});
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
  });
  const [isPersonExternalSystem, setIsPersonExternalSystem] = useState(false);
  const [externalPersonInfo, setExternalPersonInfo] = useState(false);
  const [externalPersonDocType, setExternalPersonDocType] = useState({
    docType: "",
    description: "",
    docPersonType: "",
  });
  const [externalPersonDocNumber, setExternalPersonDocNumber] = useState("");
  const [externalPersonIdCheckError, setExternalPersonIdCheckError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingAvaible, setIsFetchingAvaible] = useState(false);

  const PersonIsMinimalSelection = () => (
    <React.Fragment>
      <Row>
        <Col
          style={{
            fontWeight: "500",
            fontSize: "15px",
            display: "block",
            color: "black",
            marginBottom: "0.5rem",
          }}
        >
          Person is minimal:
        </Col>
      </Row>
      <Row>
        <Col>
          <ButtonGroup>
            <Button
              color="primary"
              onClick={() => (userSession.IsReadOnly === false ? changePersonMinimal(true) : null)}
              active={person.PersonIsMinimal == true}
            >
              Yes
            </Button>
            <Button
              onClick={() => (userSession.IsReadOnly === false ? changePersonMinimal(false) : null)}
              color="primary"
              active={person.PersonIsMinimal == false}
            >
              No
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </React.Fragment>
  );

  const color = "btn btn-ladda btn-primary";

  const toggleModalError = (e, message) =>
    setModalError({
      open: !modalError.open,
      message,
    });

  useEffect(() => {
    if (mode == PersonMode.New) {
      setDisabled(false);
    }
    setChecked(person.PersonSubAssetClass);
    const propsLegalAddress = person.LegalAddress[0] ? person.LegalAddress[0].LegalAddressCountryName : "";
    setAutosuggests({
      PersonFiscalResidenceCountry: person.PersonFiscalResidenceCountryName,
      PhysicalPersonCountryOfBirth: person.PhysicalPersonCountryOfBirthName,
      SpouseDocumentCountryOfIssue: person.SpouseDocumentCountryOfIssueName,
      LegalAddressCountry: propsLegalAddress,
      PersonActivitySector: person.PersonActivitySectorName,
      PersonSecondActivitySector: person.PersonSecondActivitySectorName,
      JuridicalPersonConstPlace: person.JuridicalPersonConstPlace,
    });
  }, [person]);

  useEffect(() => {
    if (documentTypes) {
      setExternalPersonDocType({
        docType: documentTypes[0].DocumentTypeId,
        description: documentTypes[0].DocumentTypeName,
        docPersonType: documentTypes[0].PersonType,
      });
    }
  }, [documentTypes]);

  const onChangeAutosuggest = (name, value) =>
    setAutosuggests((a) => ({
      ...a,
      [name]: value,
    }));

  const handleExternalInfo = (personId) => {
    if (person.PersonUpdateManual === "1" || person.PersonUpdateManual)
      alert("Person update is Manual, you should change it to get information from external system");
    else
      setModalConfirm((m) => ({
        ...m,
        open: !m.open,
        title: "Are you sure you want to update the selected person with info from external system?",
        personId,
        callback: () => getExternalInfo(personId),
      }));
  };

  const handleSave = () => {
    const postPerson = {
      ...person,
      ...changedPerson,
      personOnboardingId: holder,
      PersonSubAssetClass: checked,
      needsExtraFields,
    };
    const newErrors = preCheckPersonForm(postPerson);
    if (Object.keys(newErrors).length !== 0) {
      setErrors(newErrors);
      return;
    }
    const body = {
      person: postPerson,
    };
    setLoadingSave(true);
    setErrors(newErrors);
    if (onboarding || isPerson === "1") {
      const body = {
        person: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newDocuments = [...postPerson.documents];
          newDocuments.forEach((doc, i) => {
            if (
              parseInt(doc.PhysicalPersonDocumentTypeId, 10) ===
              parseInt(postPerson.PhysicalPersonMainDocumentTypeId, 10)
            ) {
              doc.PhysicalPersonDocumentNumber = postPerson.PhysicalPersonMainDocumentNumber;
            }
          });
          setPersonData({
            ...body.person,
            Documents: newDocuments,
          });
          refresh();
        } else {
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Person: ${response.result.Description}`
              : "Server Error"
          );
        }
        setLoadingSave(false);
      });
    } else {
      services.fetchUpdatePerson(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData({
            ...body.person,
            suitabilityDescription: response.result.Description,
          });
          refresh();
        } else {
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Person: ${response.result.Description}`
              : "Server Error"
          );
        }
        setLoadingSave(false);
      });
    }
  };

  const onChange = (name, value, otherValue) => {
    let newChangedPerson = {
      ...changedPerson,
      [name]: value,
    };
    const newErrors = { ...errors };
    delete newErrors[name];
    switch (name) {
      case "PersonIncomesLoad":
        // Payload del modal de ingresos (PersonIncomeModal). Solo se adjunta la
        // colección SDTPersonIncomes; el backend hace los cálculos/ponderaciones y
        // devuelve PersonAnualIncome / PersonExtraIncomeVolume (NO se setean acá).
        delete newChangedPerson.PersonIncomesLoad;
        newChangedPerson.SDTPersonIncomes = value.SDTPersonIncomes;
        break;
      case "PersonTransactionalLimit":
        newChangedPerson.PersonTransactionalLimit = value;
        break;
      case "PhysicalPersonMainDocumentTypeId":
        newChangedPerson.PhysicalPersonMainDocumentType = otherValue;
        break;
      case "SpouseDocumentCountryOfIssueId":
        newChangedPerson.SpouseDocumentCountryOfIssueName = otherValue;
        break;
      case "PhysicalPersonCountryOfBirthId":
        newChangedPerson.PhysicalPersonCountryOfBirthName = otherValue;
        newChangedPerson.PhysicalPersonCityOfBirthName = "";
        newChangedPerson.PhysicalPersonCityOfBirthId = "";
        delete newErrors.PhysicalPersonCityOfBirthId;
        break;
      case "PhysicalPersonDateOfBirth":
        newChangedPerson.PhysicalPersonDateOfBirth = value.split("T")[0];
        break;
      case "PhysicalPersonCityOfBirthId":
        newChangedPerson.PhysicalPersonCityOfBirthName = otherValue;
        break;
      case "PersonFiscalResidenceCountryId":
        newChangedPerson.PersonFiscalResidenceCountryName = otherValue;
        break;
      case "PersonProfessionId":
        newChangedPerson.PersonProfessionName = otherValue;
        break;
      case "SpouseDocumentTypeId":
        newChangedPerson.SpouseDocumentTypeName = otherValue;
        break;
      case "PhysicalPersonPublicPositionId":
        newChangedPerson.PhysicalPersonPublicPositionName = otherValue;
        break;
      case "PhysicalPersonLinkId":
        newChangedPerson.PhysicalPersonLinkName = otherValue;
        break;
      case "PersonLinkPublicPositionId":
        newChangedPerson.PersonLinkPublicPositionName = otherValue;
        break;
      case "PersonCompanyLinkId":
        newChangedPerson.PersonCompanyLinkName = otherValue;
        break;
      case "PersonActivitySectorId":
        newChangedPerson.PersonActivitySectorName = otherValue;
        break;
      case "JuridicalPersonDocumentTypeId":
        newChangedPerson.JuridicalPersonDocumentTypeName = otherValue;
        break;
      case "JuridicalPersonTAXId":
        break;
      case "PhysicalPersonMainDocumentNumber":
        break;
      case "JuridicalPersonEntityTypeId":
        newChangedPerson.JuridicalPersonEntityTypeDescription = otherValue;
        break;
      case "JuridicalPersonSocietyTypeId":
        newChangedPerson.JuridicalPersonSocietyTypeDescription = otherValue;
        break;
      case "JuridicalPersonConstPlaceId":
        newChangedPerson.JuridicalPersonConstPlace = otherValue;
        break;
      case "JuridicalPersonConstDate":
        newChangedPerson.JuridicalPersonConstDate = value.split("T")[0];
        break;
      case "PersonSecondActivitySectorId":
        newChangedPerson.PersonSecondActivitySectorName = otherValue;
        break;
      default:
      break;
    }
    setErrors(newErrors);
    setChangedPerson(newChangedPerson);
  };

  const onChangeLegalAddress = (name, value, otherValue) => {
    const newChangedLegalAddress = {
      ...changedLegalAddress,
      [name]: value,
    };
    const newErrors = { ...errors };
    delete newErrors[name];
    switch (name) {
      case "LegalAddressCountryId":
        newChangedLegalAddress.LegalAddressCountryName = otherValue;
        delete newErrors.LegalAddressStateId;
        delete newErrors.LegalAddressCityId;
        break;
      case "LegalAddressCityId":
        newChangedLegalAddress.LegalAddressCityName = otherValue;
        break;
      case "LegalAddressStateId":
        newChangedLegalAddress.LegalAddressStateName = otherValue;
        delete newErrors.LegalAddressCityId;
        break;
      default:
        break;
    }
    setChangedLegalAddress(newChangedLegalAddress);
    setErrors(newErrors);
  };

  const revert = () => {
    setChangedPerson({});
    setChangedLegalAddress({});
    setAutosuggests({
      PersonFiscalResidenceCountry: person.PersonFiscalResidenceCountryName,
      PhysicalPersonCountryOfBirth: person.PhysicalPersonCountryOfBirthName,
      SpouseDocumentCountryOfIssue: person.SpouseDocumentCountryOfIssueName,
      LegalAddressCountry: person.LegalAddress[0] ? person.LegalAddress[0].LegalAddressCountryName : "",
      PersonActivitySector: person.PersonActivitySectorName,
      PersonSecondActivitySector: person.PersonSecondActivitySectorName,
      JuridicalPersonConstPlace: person.JuridicalPersonConstPlace,
    });
    setErrors({});
  };

  const toggleDisable = () => {
    setDisabled((d) => !d);
    revert();
  };

  const changePersonType = (value) => {
    setPersonData({
      ...person,
      PersonType: value,
    });
  };

  const changePersonMinimal = (value) => {
    setPersonData({
      ...person,
      description: "PersonIsMinimal",
      PersonIsMinimal: value,
    });
    setChangedPerson({
      ...changedPerson,
      PersonIsMinimal: value,
    });
  };

  // Add/Remove checked item from list
  const handleCheck = (id) => {
    let index = -1;
    var updatedList = checked ? [...checked] : [];
    updatedList.forEach((doc, i) => {
      if (parseInt(doc.PersonSubAssetClassId) === parseInt(id)) {
        index = i;
      }
    });
    if (index > -1) {
      updatedList.splice(index, 1);
    } else {
      updatedList.push({ PersonSubAssetClassId: id });
    }
    setChecked(updatedList);
  };

  // Return classes based on whether item is checked
  function isChecked(id) {
    var updatedList = checked ? [...checked] : [];
    updatedList.forEach((doc, i) => {
      if (parseInt(doc.PersonSubAssetClassId) == parseInt(id)) {
        return true;
      }
    });
  }

  const getExternalInfo = () => {
    setModalConfirm((m) => ({
      ...m,
      open: true,
      loading: true,
    }));
    const body = {
      personid: person.PersonId,
      onboardingProcessId: onboarding,
      isOnboarding: mode == PersonMode.New,
    };
    services.fetchExternalPerson(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false,
        });
        refresh();
      } else {
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false,
        });
        toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
      }
    });
  };

  const handleNewSave = () => {
    const postPerson = {
      ...person,
      ...changedPerson,
      PersonSubAssetClass: checked,
      needsExtraFields,
    };
    const newErrors = preCheckPersonForm(postPerson);
    if (Object.keys(newErrors).length !== 0) {
      setErrors(newErrors);
      return;
    }
    const body = {
      person: postPerson,
    };
    setLoadingSave(true);
    setErrors(newErrors);
    services.fetchUpdatePerson(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        if (postPerson.personId == 0 && response.newPersonId > 0) {
          postPerson.personId = response.newPersonId;
          postPerson.PersonId = response.newPersonId;
        }
        const newPerson = {
          person: postPerson,
        };
        setPersonData({
          ...postPerson,
          suitabilityDescription: response.result.Description,
        });
      } else {
        toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
      }
      setLoadingSave(false);
    });
  };

  const handleOnboardingSave = () => {
    const postPerson = {
      ...person,
      ...changedPerson,
      PersonOnboardingId: holder,
      PersonSubAssetClass: checked,
      needsExtraFields,
    };

    const newErrors = preCheckPersonForm(postPerson);
    if (Object.keys(newErrors).length !== 0) {
      setErrors(newErrors);
      return;
    }
    setLoadingSave(true);
    setErrors(newErrors);
    
    let idOnb = "";
    if (onboarding !== undefined && onboarding != 0) idOnb = onboarding;
    if (idOnb == "" && postPerson.PersonId != 0) idOnb = postPerson.PersonId;

    if (newOnboardingVersion) {
      const baseBody = {
        trnmode: "INS",
        PersonId: 0,
        personData: JSON.stringify({
          Entity: "Person",
          Data: {
            PersonId: 0,
            PersonType: postPerson.PersonType,
            PersonStatus: postPerson.PersonStatus,
            PersonEmail: postPerson.PhysicalPersonEmail || postPerson.PersonEmail,
            UserGUID: postPerson.PersonUserGUID,
            PersonProfessionId: postPerson.PersonProfessionId,
            PersonActivitySectorId: postPerson.PersonActivitySectorId,
            PersonAnualIncome: postPerson.PersonAnualIncome,
            PersonCompanyLinkId: postPerson.PersonCompanyLinkId,
            PersonObservations: postPerson.PersonObservations,
            PersonExternalReferenceId: postPerson.PersonExternalId,
            PersonRisk: postPerson.PersonRisk,
            PersonProfileRisk: postPerson.PersonProfileRisk,
            PersonTransactionalLimit: postPerson.PersonTransactionalLimit,
            PersonActivationDate: postPerson.PersonActivationDate,
            PersonLastLegalContractId: postPerson.PersonLastLegalContractId,
            PersonUpdateManual: postPerson.PersonUpdateManual,
            PersonObligatedEntity: postPerson.PersonObligatedEntity,
            PersonCurrencyType: postPerson.PersonCurrencyType,
            PersonRelatedFrom: postPerson.PersonRelatedFrom,
            PersonExtraIncomeVolume: postPerson.PersonExtraIncomeVolume,
            PersonQualification: postPerson.PersonQualification,
            PersonIsMinimal: postPerson.PersonIsMinimal,
            PersonProcessResult: postPerson.PersonProcessResult,
            PersonSecondActivitySectorId: postPerson.PersonSecondActivitySectorId,
          }
        })
      };
      let body = {...baseBody};
      setLoadingSave(true);

      const callFetchNewPersonSubAssetClass = async (personId) => {
        if (!postPerson.PersonSubAssetClass || postPerson.PersonSubAssetClass.length === 0) return;

        const subAssetBody = {
          trnmode: "INS",
          PersonId: personId,
          personSubAssetClass: postPerson.PersonSubAssetClass.map((item) => ({
            PersonSubAssetClassId: item.PersonSubAssetClassId,
            PersonSubAssetClassName: "",
            PersonId: personId
          })) 
        };

        await services.fetchNewPersonSubAssetClass(subAssetBody, (response) => {
          if (response && response.result && response.result.Code === 200) {
            refresh();
          } else { 
            toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
          }
        });
      };

      if (postPerson.PersonType === "Physical") {
        body.physicalPerson = JSON.stringify({
          Entity: "PhysicalPerson",
          Data: {
            PhysicalPersonId: postPerson.PhysicalPersonId || 0,
            PhysicalPersonFirstName: postPerson.PhysicalPersonFirstName,
            PhysicalPersonSecondName: postPerson.PhysicalPersonSecondName,
            PhysicalPersonFirstLastName: postPerson.PhysicalPersonFirstLastName,
            PhysicalPersonSecondLastName: postPerson.PhysicalPersonSecondLastName,
            PhysicalPersonDateOfBirth: postPerson.PhysicalPersonDateOfBirth,
            PhysicalPersonCivilStatus: postPerson.PhysicalPersonCivilStatus,
            SpouseFirstName: postPerson.SpouseFirstName,
            SpouseSecondName: postPerson.SpouseSecondName,
            SpouseFirstLastName: postPerson.SpouseFirstLastName,
            SpouseSecondLastName: postPerson.SpouseSecondLastName,
            SpouseDocumentNumber: postPerson.SpouseDocumentNumber,
            SpouseDocumentCountryOfIssueId: postPerson.SpouseDocumentCountryOfIssueId,
            PhysicalPersonFormalName: postPerson.PhysicalPersonFormalName,
            PhysicalPersonCityOfBirthId: postPerson.PhysicalPersonCityOfBirthId === "" ? 0 : postPerson.PhysicalPersonCityOfBirthId,
            PhysicalPersonCityOfBirthName: postPerson.PhysicalPersonCityOfBirthName,
            PhysicalPersonCountryOfBirthId: postPerson.PhysicalPersonCountryOfBirthId,
            PhysicalPersonPublicPositionId: postPerson.PhysicalPersonPublicPositionId,
            PersonLinkPublicPositionId: postPerson.PersonLinkPublicPositionId,
            PhysicalPersonLinkId: postPerson.PhysicalPersonLinkId,
            SpouseDocumentTypeId: postPerson.SpouseDocumentTypeId,
            SpouseDocumentExpirationDate: postPerson.SpouseDocumentExpirationDate,
            SpouseDocumentWithoutExpiratio: postPerson.SpouseDocumentWithoutExpiration,
            PhysicalPersonPatrimonyId: postPerson.PhysicalPersonPatrimonyId,
            PhysicalPersonWorkHistoryActiv: postPerson.PhysicalPersonWorkHistoryActivities,
            PhysicalPersonWorkHistoryYears: postPerson.PhysicalPersonWorkHistoryYears,
            PhysicalPersonWorkHistoryRelev: postPerson.PhysicalPersonWorkHistoryRelevantPosition,
            PhysicalPersonWorkHistoryIncom: postPerson.PhysicalPersonWorkHistoryIncome === "" ? 0 : postPerson.PhysicalPersonWorkHistoryIncome,
            PhysicalPersonWebUser: postPerson.PhysicalPersonWebUser,
            PhysicalPersonInstitution: postPerson.PhysicalPersonInstitution,
            PhysicalPersonGender: postPerson.PhysicalPersonGender,
            PhysicalPersonMainDocTypeId: postPerson.PhysicalPersonMainDocumentTypeId,
            PhysicalPersonMainDocNumber: postPerson.PhysicalPersonMainDocumentNumber,
            PhysicalPersonWorkingIndustry: postPerson.PhysicalPersonWorkingIndustry,
            PhysicalPersonPositionIndustry: postPerson.PhysicalPersonPositionIndustry,
            PhysicalPersonNationality: postPerson.PhysicalPersonNationality,
          },
        });

        services.fetchNewPhysicalPerson(body, async (response) => {
          if (response && response.result && response.result.Code === 200) {
            if (postPerson.personId === 0 && response.PersonId > 0 || postPerson.PersonId === 0 && response.PersonId > 0) {
              postPerson.personId = response.PersonId;
              postPerson.PersonId = response.PersonId;
              await callFetchNewPersonSubAssetClass(response.PersonId);
              handleRedirectPerson(response.PersonId);
            }
            let index = -1;
            const newDocuments = [...postPerson.Documents];
            newDocuments.forEach((doc, i) => {
              if (
                parseInt(doc.PhysicalPersonDocumentTypeId, 10) ===
                parseInt(postPerson.PhysicalPersonMainDocumentTypeId, 10)
              ) {
                doc.PhysicalPersonDocumentNumber = postPerson.PhysicalPersonMainDocumentNumber;
                doc.PhysicalPersonDocumentTypeName = postPerson.PhysicalPersonMainDocumentType;
                index = i;
              }
            });
            if (index < 0) {
              const newDoc = {
                PhysicalPersonDocumentNumber: postPerson.PhysicalPersonMainDocumentNumber,
                PhysicalPersonDocumentTypeId: postPerson.PhysicalPersonMainDocumentTypeId,
                PhysicalPersonDocumentTypeName: postPerson.PhysicalPersonMainDocumentType,
              };
              newDocuments.push(newDoc);
            }

            setPersonData({
              ...body.postPerson,
              Documents: newDocuments,
            });
            refresh();
          } else {
            toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
          }
          setLoadingSave(false);
        });
      } else {
        body.juridicalPerson = JSON.stringify({
          Entity: "JuridicalPerson",
          Data: {
            JuridicalPersonId: postPerson.JuridicalPersonId || 0,
            JuridicalPersonName: postPerson.JuridicalPersonName,
            JuridicalPersonLegalName: postPerson.JuridicalPersonLegalName,
            JuridicalPersonTAXId: postPerson.JuridicalPersonTAXId,
            JuridicalPersonConstDate: postPerson.JuridicalPersonConstDate,
            JuridicalPersonIssuePlace: postPerson.JuridicalPersonIssuePlace,
            JuridicalPersonSecurityNumber: postPerson.JuridicalPersonSecurityNumber,
            JuridicalPersonRegFinalBenefic: postPerson.JuridicalPersonRegFinalBeneficiaries,
            JuridicalPersonDocumentTypeId: postPerson.JuridicalPersonDocumentTypeId,
            JuridicalPersonConstPlaceId: postPerson.JuridicalPersonConstPlaceId,
            JuridicalPersonEntityTypeId: postPerson.JuridicalPersonEntityTypeId,
            JuridicalPersonSocietyType: postPerson.JuridicalPersonSocietyType,
            JuridicalPersonSocietyTypeId: postPerson.JuridicalPersonSocietyTypeId,
            JuridicalPersonPublicPosition: postPerson.JuridicalPersonPublicPosition,
            JuridicalPersonShareType: postPerson.JuridicalPersonShareType,
          },
        });

        services.fetchNewJuridicalPerson(body, async (response) => {
          if (response && response.result && response.result.Code === 200) {
            if (postPerson.personId === 0 && response.PersonId > 0 || postPerson.PersonId === 0 && response.PersonId > 0) {
              postPerson.personId = response.PersonId;
              postPerson.PersonId = response.PersonId;
              await callFetchNewPersonSubAssetClass(response.PersonId);
              handleRedirectPerson(response.PersonId);
            }

            setPersonData({
              ...postPerson
            });
            refresh();
          } else {
            toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
          }
          setLoadingSave(false);
        });
      }
    }else{
      const body = { OnboardingId: String(idOnb), postPerson, };

      services.fetchNewPerson(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          if (postPerson.personId == 0 && response.newPersonId > 0 || postPerson.PersonId == 0 && response.newPersonId > 0) {
            postPerson.personId = response.newPersonId;
            postPerson.PersonId = response.newPersonId;
            handleRedirectPerson(response.newPersonId);
          }
          let index = -1;
          const newDocuments = [...postPerson.Documents];
          newDocuments.forEach((doc, i) => {
            if (
              parseInt(doc.PhysicalPersonDocumentTypeId, 10) ===
              parseInt(postPerson.PhysicalPersonMainDocumentTypeId, 10)
            ) {
              doc.PhysicalPersonDocumentNumber = postPerson.PhysicalPersonMainDocumentNumber;
              doc.PhysicalPersonDocumentTypeName = postPerson.PhysicalPersonMainDocumentType;
              index = i;
            }
          });
          if (index < 0) {
            const newDoc = {
              PhysicalPersonDocumentNumber: postPerson.PhysicalPersonMainDocumentNumber,
              PhysicalPersonDocumentTypeId: postPerson.PhysicalPersonMainDocumentTypeId,
              PhysicalPersonDocumentTypeName: postPerson.PhysicalPersonMainDocumentType,
            };
            newDocuments.push(newDoc);
          }
  
          setPersonData({
            ...body.postPerson,
            Documents: newDocuments,
          });
          refresh();
        } else {
          toggleModalError({}, response && response.result ? response.result.Description : "Server Error");
        }
        setLoadingSave(false);
      });
    }
  };

  if (!person) {
    return <Spinner />;
  }

  const legalAddress = person.LegalAddress[0] || {};

  const onChangeDoc = (name, value, otherValue) => {
    const document = documentTypes ? documentTypes.filter((d) => d.DocumentTypeId == value) : [];
    setExternalPersonDocType({
      docType: value,
      description: otherValue,
      docPersonType: document.length > 0 ? document[0].PersonType : PersonType.All,
    });
  };

  const onChangeDocNumber = (id, value) => {
    setExternalPersonDocNumber(value);
    setIsFetchingAvaible(false);
  };

  const checkDocument = () => {
    setIsLoading(true);
    services.fetchCheckDocument(
      {
        type: externalPersonDocType.docType,
        number: externalPersonDocNumber,
        person: externalPersonDocType.docPersonType,
      },
      (response) => {
        setIsLoading(false);

        if (response && response.result.Code === 200) {
          setExternalPersonIdCheckError(undefined);
          setIsFetchingAvaible(true);
        } else {
          setExternalPersonIdCheckError("This document already exists");
          setIsFetchingAvaible(false);
        }
      }
    );
  };

  const getExternalPerson = () => {
    setIsLoading(true);
    const payload = { documentType: externalPersonDocType.docType, documentNumber: externalPersonDocNumber };
    services.fetchExternalPerson(payload, (res) => {
      const { response } = res;
      if (response.errorMessage == "") {
        if (response && response.SDTcompliancePerson) {
          const externalPerson = {
            ...response.SDTcompliancePerson,
            PersonIsMinimal: person.PersonIsMinimal,
          };
          setPersonData(externalPerson);
          setExternalPersonInfo(1);
          refresh();
        }
      } else {
        //ERROR HANDLING
        setPersonData((prevState) => ({ ...prevState, PersonProcessResult: response.errorMessage }));
      }
      setIsLoading(false);
    });
  };

  return (
    <div>
      <Form>
        {person.useAlternativeRoute && externalPersonInfo == "" ? (
          <Row>
            <Col>
              <SelectFormField
                label="Load person from External System?:"
                value={isPersonExternalSystem ? 1 : 0}
                onChange={(e) => {
                  setIsPersonExternalSystem(!isPersonExternalSystem);
                }}
                selectItems={[1, 0]}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
              />
            </Col>
            <Col></Col>
          </Row>
        ) : null}
        {isPersonExternalSystem && externalPersonInfo == "" ? (
          <div>
            <PersonIsMinimalSelection />
            <Row>
              <Col>
                <SelectFormField
                  label="Document Type"
                  value={externalPersonDocType.docType}
                  onChange={onChangeDoc}
                  name="ExternalPersonDocumentType"
                  selectItems={documentTypes}
                  getSelectItemId={(doc) => doc.DocumentTypeId}
                  getSelectItemName={(doc) => doc.DocumentTypeName}
                />
              </Col>
              <Col>
                <FormField
                  label="Document Number"
                  value={externalPersonDocNumber}
                  name="ExternalPersonDocumentNumber"
                  onChange={onChangeDocNumber}
                  error={externalPersonIdCheckError}
                />
              </Col>
              <Col>
                <Label>Check if the person already exist</Label>
                <div></div>
                <LaddaButton
                  className={color}
                  loading={isLoading}
                  onClick={checkDocument}
                  data-style={EXPAND_RIGHT}
                  color={color}
                >
                  <i className="fa fa-check-square" aria-hidden="true"></i>
                </LaddaButton>
              </Col>
              <Col>
                <Label>Retrieve person from external system</Label>
                <div></div>
                <LaddaButton
                  className={color}
                  loading={isLoading}
                  onClick={getExternalPerson}
                  disabled={!isFetchingAvaible}
                  data-style={EXPAND_RIGHT}
                  title={!isFetchingAvaible ? "You must first check whether the person already exists" : null}
                >
                  <i className="icon-user" />
                </LaddaButton>
              </Col>
            </Row>
            <Row>
              <Col>
                <Label>Result from external system</Label>
                <Input type="textarea" value={person.PersonProcessResult} disabled={true} />
              </Col>
            </Row>
            <br />
          </div>
        ) : (
          <div>
            <PersonIsMinimalSelection />
            {!person.PersonIsMinimal && (
              <div>
                <Row>
                  <Col>
                    <SelectFormField
                      label="Update Manual?: "
                      value={
                        changedPerson && changedPerson.PersonUpdateManual
                          ? changedPerson.PersonUpdateManual
                          : person.PersonUpdateManual
                          ? "1"
                          : "0"
                      }
                      selectItems={[1, 0]}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                      name="PersonUpdateManual"
                      onChange={onChange}
                    />
                  </Col>
                  <Col>
                    {person.useAlternativeRoute
                      ? null
                      : userSession.IsReadOnly === false && (
                          <div>
                            <Label>Person Info from external system</Label>
                            <div></div>
                            <LaddaButton
                              className={color}
                              loading={checking}
                              onClick={() => handleExternalInfo()}
                              data-style={EXPAND_RIGHT}
                              color={color}
                            >
                              <i className="fa fa-info" aria-hidden="true"></i>
                            </LaddaButton>
                          </div>
                        )}
                  </Col>
                </Row>
                {person.useAlternativeRoute ? null : (
                  <Row>
                    <Col>
                      <Label>Result from External System</Label>
                      <Input type="textarea" value={person.PersonProcessResult} disabled={true} />
                    </Col>
                  </Row>
                )}
              </div>
            )}
            {mode == PersonMode.New && (
              <React.Fragment>
                <Row>
                  <Col
                    style={{
                      fontWeight: "500",
                      fontSize: "15px",
                      display: "block",
                      color: "black",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Select type:
                  </Col>
                </Row>
                <Row>
                  <Col style={{ marginBottom: "0.5rem" }}>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        onClick={() => changePersonType(PersonType.Physical)}
                        active={person.PersonType === PersonType.Physical}
                      >
                        Physical
                      </Button>
                      <Button
                        onClick={() => changePersonType(PersonType.Juridical)}
                        color="primary"
                        active={person.PersonType === PersonType.Juridical}
                      >
                        Juridical
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <FormGroup tag="fieldset">
              {person.PersonType === PersonType.Physical ? (
                <PhysicalPersonProfile
                  mode={mode}
                  person={{ ...person, ...changedPerson }}
                  legalAddress={{ ...legalAddress, ...changedLegalAddress }}
                  onChange={onChange}
                  onChangeAddress={onChangeLegalAddress}
                  personLinks={personLinks}
                  publicPositions={publicPositions}
                  professions={professions}
                  activitySectors={activitySectors}
                  documentTypes={
                    documentTypes
                      ? documentTypes.filter((d) => d.PersonType.trim() === PersonType.Physical)
                      : undefined
                  }
                  companyLinks={companyLinks}
                  patrimonies={patrimonies}
                  autosuggests={autosuggests}
                  onChangeAutosuggest={onChangeAutosuggest}
                  disabled={disabled}
                  errors={errors}
                  services={services}
                  onboarding={onboarding}
                  setDisabled={setDisabled}
                  manual={manual}
                  role={role}
                  viewDigitalRelatedFrom={viewDigitalRelatedFrom}
                  currencies={currencies}
                  refresh={refresh}
                />
              ) : (
                <JuridicalPersonProfile
                  mode={mode}
                  person={{ ...person, ...changedPerson }}
                  legalAddress={{ ...legalAddress, ...changedLegalAddress }}
                  onChange={onChange}
                  documentTypes={
                    documentTypes
                      ? documentTypes.filter((d) => d.PersonType.trim() === PersonType.Juridical)
                      : undefined
                  }
                  societyTypes={societyTypes}
                  publicPositions={publicPositions}
                  entityTypes={entityTypes}
                  activitySectors={activitySectors}
                  onChangeAddress={onChangeLegalAddress}
                  autosuggests={autosuggests}
                  onChangeAutosuggest={onChangeAutosuggest}
                  disabled={disabled}
                  setDisabled={setDisabled}
                  errors={errors}
                  companyLinks={companyLinks}
                  professions={professions}
                  services={services}
                  role={role}
                  holder={holder}
                  onboarding={onboarding}
                  manual={manual}
                  needsExtraFields={needsExtraFields}
                  currencies={currencies}
                  refresh={refresh}
                />
              )}
              <Row>
                <React.Fragment>
                  <Col>
                    {PersonQualification ? (
                      <SelectFormField
                        label="Person Qualification"
                        name="PersonQualification"
                        onChange={onChange}
                        value={
                          changedPerson && changedPerson.PersonQualification
                            ? changedPerson.PersonQualification
                            : person.PersonQualification
                        }
                        selectItems={PersonQualification}
                        getSelectItemId={(i) => i.id}
                        error={errors.PersonQualification}
                        getSelectItemName={(i) => i.name}
                      />
                    ) : (
                      <CircularProggress sm />
                    )}
                  </Col>
                </React.Fragment>
              </Row>
              <Col>
                <PersonSubAsset
                  person={person}
                  onChange={onChange}
                  subAssetClasses={subAssetClasses}
                  isChecked={isChecked}
                  checked={checked}
                  handleCheck={handleCheck}
                />
              </Col>
            </FormGroup>
          </div>
        )}
      </Form>
      <ModalError {...modalError} onToggle={toggleModalError} />
      <ModalConfirm
        open={modalConfirm.open}
        toggle={handleExternalInfo}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
      {onboarding || isPerson ? (
        <React.Fragment>
          <Row style={{ textAlign: "right" }}>
            <Col>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={loadingSave}
                onClick={handleOnboardingSave}
                data-style={EXPAND_RIGHT}
                disabled={disabled}
              >
                {loadingSave ? "Saving" : "Save"}
              </LaddaButton>
            </Col>
          </Row>
        </React.Fragment>
      ) : mode == PersonMode.New ? (
        <React.Fragment>
          <Row style={{ textAlign: "right" }}>
            <Col>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={loadingSave}
                onClick={handleNewSave}
                data-style={EXPAND_RIGHT}
              >
                {loadingSave ? "Saving" : "Save"}
              </LaddaButton>
            </Col>
          </Row>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {disabled && userSession.IsReadOnly === false && (
            <Button color="secondary" onClick={toggleDisable} style={{ marginRight: 10 }}>
              <i className="fa fa-lock" /> Edit
            </Button>
          )}
          {!disabled && (
            <React.Fragment>
              <Button color="secondary" onClick={toggleDisable} style={{ marginRight: 10 }}>
                <i className="fa fa-unlock" /> Lock
              </Button>
              <Button
                color="secondary"
                onClick={revert}
                style={{ marginRight: 10 }}
                disabled={
                  (Object.keys(changedPerson) === 0 && Object.keys(changedLegalAddress) === 0) || loadingSave
                }
              >
                <i className="fa fa-undo" /> Revert
              </Button>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={loadingSave}
                disabled={
                  (Object.keys(changedPerson) === 0 && Object.keys(changedLegalAddress) === 0) || loadingSave
                }
                onClick={handleSave}
                data-style={EXPAND_RIGHT}
              >
                {loadingSave ? "Saving" : "Save"}
              </LaddaButton>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

PersonProfileTab.propTypes = {
  person: PropTypes.object.isRequired,
  setPersonData: PropTypes.func.isRequired,
  professions: PropTypes.array,
  publicPositions: PropTypes.array,
  personLinks: PropTypes.array,
  documentTypes: PropTypes.array,
  companyLinks: PropTypes.array,
  patrimonies: PropTypes.array,
  entityTypes: PropTypes.array,
  societyTypes: PropTypes.array,
  services: PropTypes.object.isRequired,
  role: PropTypes.string,
};

PersonProfileTab.defaultProps = {
  professions: undefined,
  publicPositions: undefined,
  personLinks: undefined,
  documentTypes: undefined,
  companyLinks: undefined,
  patrimonies: undefined,
  entityTypes: undefined,
  societyTypes: undefined,
};

export default PersonProfileTab;
